const CheckBoxInput = ({ id, name, label, subLabel, onChange }) => {
  return (
    <div className="flex items-start">
      <div className="flex items-center h-5">
        <input
          id={id}
          name={name}
          type="checkbox"
          className="focus:ring-artfulRed-550 h-4 w-4 text-artfulRed border-gray-300 rounded"
          onChange={onChange}
        />
      </div>
      <div className="ml-3 text-sm">
        <label htmlFor={id} className="font-medium text-gray-700">
          {label}
        </label>
        {subLabel && <p className="text-gray-500">{subLabel}</p>}
      </div>
    </div>
  )
};

export default CheckBoxInput;
